export async function fillStoreForDetail() {}
